export const ACCESS_TOKEN = "access_token";
export const REFRESH_TOKEN = "refresh_token";
export const USER = "user";
export const REDIRECT_AFTER_LOGIN = "redirectAfterLogin";

// Synchronous, crash-proof accessor for storage reads that happen at render
// time (e.g. App.js reading the token before the first paint). Safari private
// mode / restricted webviews throw a SecurityError from localStorage.getItem
// itself, not just from JSON.parse — a plain try/catch around the read is
// required, unlike StorageGetItem below which only guards the parse step.
export function safeGetItem(key) {
  try {
    const value = localStorage.getItem(key);
    return value === undefined ? null : value;
  } catch (error) {
    return null;
  }
}

export async function StorageGetItem(key) {
  try {
    const value = localStorage.getItem(key);

    if (value !== undefined) {
      return await JSON.parse(value);
    }
  } catch (error) {
    return error;
  }
}

export async function StorageSetItem(key, value) {
  try {
    await localStorage.setItem(key, JSON.stringify(value));
    window.dispatchEvent(new Event(key));
    return true;
  } catch (error) {
    return error;
  }
}

export async function StorageClearAll() {
  try {
    await localStorage.clear();
  } catch (error) {
    return error;
  }
}

export async function addEventListenerHook(key, callback) {
  try {
    window.addEventListener(key, async () => callback && callback());
    return true;
  } catch (error) {
    return error;
  }
}
